import { ThemeConfig } from 'antd';

const INPUT_HEIGHT_LG = 48;
export const HEADER_HEIGHT = 76;
export const SEGMENTS_HEIGHT = 46;

export const commonCssVars = {
  'max-content-width': '1624px',
  'padding-y-layout': '22px',
  'padding-y-mobile': '16px',
  'padding-x-layout': 'clamp(24px, 4.5vw, 161px)',
  'padding-y-content': 'clamp(24px, 4vw, 41px)',
  'padding-y-menu': '16px',
  'padding-x-menu': '24px',
  'content-padding': '12px',
  'header-height': `${HEADER_HEIGHT}px`,
  'header-height-mobile': '46px',
  'footer-height': '76px',
  'segmented-height': `${SEGMENTS_HEIGHT}px`,

  'card-padding-y': 'clamp(24px, 5vw, 32px)',
  'card-padding-x': 'clamp(16px, 5vw, 24px)',

  'border-radius-none': '0px',
  'border-radius-default': '4px',
  'border-radius-medium': '8px',
  'border-radius-large': '16px',

  'button-border-radius': 'var(--border-radius-default)',

  'button-height-lg': '52px',
  'button-sm-icon-margin-inline-end': '0px',

  'color-white': '#ffffff',
  'color-black': '#000000',
  'color-bg-mask': 'rgba(0, 0, 0, 0.06)',

  'input-height-lg': `${INPUT_HEIGHT_LG}px`,
  'input-height-lg-prefix': '32px',
  'input-border-radius': 'var(--border-radius-default)',

  'descriptions-table-layout': 'auto',
  'descriptions-row-padding-bottom': '0',
  'descriptions-row-padding-right': '33px',

  'tag-margin-inline-end': '0',

  'statistic-prefix-margin': '0',

  'table-header-color': '#969696',
  'table-header-font-size': '12px',
  'table-header-font-weight': '400',

  'table-header-border-display': 'none',
  'table-header-text-align': 'center',
  'table-body-text-align': 'center',
  'table-body-font-size': '12px',
  'table-body-whitespace': 'nowrap',
  'table-row-hover': 'rgba(253, 28, 124, 0.1)',
  'table-td-padding-left': '8px',
  'table-border-radius': '0',
  'table-header-whitespace': 'nowrap',
  'table-header-bg-has-sort': 'rgb(245, 245, 245)',
  'color-error-message': '#bf1650',
  'color-rail-default': '#e1e1e1',
  'color-danger': '#ff4d9e',
  colorDescription: '#4b4b4b',
  colorBlack: '#000000',

  'nav-menu-border-color': 'var(--border-color)',
  'nav-menu-bg-hamburger': '#e1e1e1',
  'nav-menu-active-color': '#FFFFF',
  'nav-menu-icon-size': '24px',
  'nav-menu-label-font-size': '14px',

  'text-level-first': '48px',
  'text-level-first-mobile': '32px',
  'text-level-second': '32px',
  'text-level-second-mobile': '28px',
  'text-level-third': '24px',
  'text-level-third-mobile': '16px',
  'text-level-fourth': '20px',
  'text-level-fourth-mobile': '18px',
  'text-level-fifth': '18px',
  'text-level-fifth-mobile': '16px',
  'text-level-sixth': '16px',
  'text-level-sixth-mobile': '14px',
  'text-level-seventh': '14px',
  'text-level-seventh-mobile': '12px',
  'text-level-eighth': '12px',
  'text-level-eighth-mobile': '12px',
  'text-level-ninth': '11px',
  'text-level-tenth': '9px',
  'text-level-tenth-mobile': '8px',
  'evaluation-color': 'var(--colorSecondary)',
  'demo-color': 'var(--colorSuccess)',
  'competition-color': 'var(--colorInfo)',
  'funded-color': 'var(--colorPrimary)',
  'contest-color': 'var(--colorSuccess)',
  'cart-background': '#282c38',
};

export const commonLightCssEnv = {
  'radio-active-button-shadow': '6px 15px 25px 0px rgba(190, 200, 218, 0.40)',
  'sider-shadow': '6px 15px 25px 0px rgba(207, 212, 220, 0.4)',
  'header-shadow': '6px 15px 25px 0px rgba(207, 212, 220, 0.4)',
  'header-border-color': '#e1e1e1',
  'header-minimal-bg': '#fff',
  'header-avatar-color': '#000000',
  'card-border-color': '#e1e1e1',
  'color-text-seed': '#000000',
  'table-header-bg': '#f6f6f6',
  'table-header-bg-has-sort': 'rgb(245, 245, 245)',
  'table-fixed-column-shadow':
    'inset -10px 0 8px -8px rgba(193, 193, 193, 0.35)',
  'border-color': '#e1e1e1',
  'card-shadow': '6px 15px 25px 0px rgba(190, 200, 218, 0.4)',
  'card-shadow-small': '1px 5px 4px 0px rgba(193, 193, 193, 0.35)',
  'card-shadow-hover': '6px 15px 25px 0px rgba(190, 200, 218, 0.40)',
  'radio-active-button-font-weight': '600',
  'input-border-color': '#afafaf',
  colorReverse: '#FFFFFF',
  colorBgBase: '#fff',
  'color-bg-box': '#FFFFFF',
  'coupon-img-filter':
    'drop-shadow(1.378px 3.446px 5.743px rgba(190, 200, 218, 0.4))',
  'icon-drop-shadow-filter':
    'drop-shadow(1px 5px 4px rgba(193, 193, 193, 0.35))',
  'account-item-bg-disabled': '#F6F6F6',
  'color-bg-content': '#F6F6F6',
  'color-text-description': '#4B4B4B',
  'shiny-border-color':
    'radial-gradient(transparent, transparent, #1a2052, #828ce5, #1a2052, #828ce5, transparent, transparent)',
  'color-active-menu-tag-5ers': 'var(--colorWarning)',
  'color-active-menu-tag-ttp': 'var(--color-white)',
  'medium-grey': '#A0A0A0',
  'lightest-grey': '#fdfbfb',
  lightbox: 'rgba(149, 149, 149, 0.50)',
  'support-card-bg': '#E9E8F5',
  'action-btns-bg': '#f6f6f6',
  'purchases-table-header-bg': '#f9f9ff',
  'dropdown-hover-bg': '#F9F9FF',
  'dropdown-selected-bg': 'rgba(132, 88, 252, 0.20)',
  'dropdown-text-color': 'inherit',
};

export const commonDarkCssEnv = {
  'radio-active-button-shadow': 'unset',
  'header-shadow': 'unset',
  'header-border-color': '#454C52',
  'header-minimal-bg': 'var(--color-bg-box)',
  'header-avatar-color': '#ffffff',
  'table-header-bg': '#1A1D21',
  'table-header-bg-has-sort': 'var(--color-sorted-cells)',
  'table-fixed-column-shadow': 'inset -10px 0 8px -8px rgba(0, 0, 0, 0.40)',
  'radio-active-button-font-weight': '600',
  'sider-shadow': '6px 15px 25px 0px rgba(0, 0, 0, 0.40)',
  'card-active-border-color': '#6710FF',
  'card-border-color': '#454C52',
  'card-shadow': '6px 15px 25px 0px rgba(0, 0, 0, 0.40)',
  'card-shadow-small': '1px 5px 4px 0px rgba(0, 0, 0, 0.35)',
  'card-shadow-hover': 'unset',
  'color-text-seed': '#DDDDDD',
  'border-color': '#454C52',
  'input-border-color': '#454C52',
  colorReverse: '#000000',
  colorBgBase: '#1A1D21',
  'color-bg-box': '#292E32',
  'coupon-img-filter': 'unset',
  'icon-drop-shadow-filter': 'drop-shadow(1px 5px 4px rgba(28, 28, 28, 0.65))',
  'account-item-bg-disabled': '#1A1D21',
  'color-bg-content': '#1C2024',
  'color-text-description': '#8F8F8F',
  'shiny-border-color': 'radial-gradient(#1a2052, #828ce5, #1a2052, #828ce5)',
  'color-active-menu-tag-5ers': '#FFFFFF',
  'color-active-menu-tag-ttp': '#475057',
  'medium-grey': '#A0A0A0',
  'lightest-grey': '#141619',
  lightbox: 'rgba(75, 75, 75, 0.50)',
  'support-card-bg': '#242630',
  'action-btns-bg': '#22262B',
  'purchases-table-header-bg': '#1A1D21',
  'dropdown-hover-bg': 'var(--ant-color-primary)',
  'dropdown-selected-bg': 'var(--ant-color-primary)',
  'dropdown-text-color': '#000000',
};

export const common5ersCssVars = {
  'color-coupon-credits': '#808596',
  'color-coupon-credits-decorate': '#FFF',
  'color-coupon-general': '#179DA6',
  'color-coupon-general-decorate': '#02D0C6',
  'color-coupon-program': '#D3AD00',
  'color-coupon-program-decorate': '#FFCD06',
  'color-coupon-addon': '#434EB0',
  'color-coupon-addon-decorate': '#02D0C6',
  'color-coupon-ribbon': '#E9C10F',
  'color-sorted-cells': '#141619',
  'color-divider-light': '#DBDBDB',
  'color-divider-dark': '#434C53',
  'color-affiliation-welcome': '#1A2052',
  'color-affiliation-welcome-text': '#FFD30E',
  'funded-color': 'var(--colorError)',
};

export const commonTtpCssVars = {
  'color-coupon-credits': '#00A7B2',
  'color-coupon-credits-decorate': '#FFF',
  'color-coupon-general': '#9558FF',
  'color-coupon-general-decorate': '#FFF',
  'color-coupon-program': '#D3AD00',
  'color-coupon-program-decorate': '#FFF',
  'color-coupon-addon': '#256BE4',
  'color-coupon-addon-decorate': '#FFF',
  'color-coupon-ribbon': '#E9C10F',
  'color-sorted-cells': '#1C2024',
  'color-divider-light': '#DBDBDB',
  'color-divider-dark': '#434C53',
  'color-affiliation-welcome': '#1E1E1E',
  'color-affiliation-welcome-text': '#FF4D9E',
  'evaluation-color': 'var(--colorWarning)',
  'demo-color': 'var(--colorInfo)',
  'competition-color': 'var(--colorAttention)',
  'funded-color': 'var(--colorPrimary)',
};

export const commonComponentTheme: ThemeConfig['components'] = {
  Typography: {
    fontFamily: 'Mona Sans',
    colorText: 'var(--color-text-seed)',
  },
  Layout: {
    headerBg: 'transparent',
  },
  Menu: {
    iconMarginInlineEnd: 16,
    itemBorderRadius: 0,
    itemHeight: 40,
    itemMarginInline: 0,
    itemSelectedColor: '#FFFFFF',
    colorBgMask: 'transparent',
    colorBorder: 'transparent',
    colorBorderBg: 'transparent',
    itemActiveBg: 'var(--colorAttention)',
    itemSelectedBg: 'var(--colorAttention)',
    activeBarBorderWidth: 0,
  },
  Drawer: {
    colorBgMask: 'rgba(0, 0, 0, 0.06)',
    paddingXL: 0,
    paddingLG: 0,
    paddingMD: 0,
    paddingSM: 0,
    paddingXS: 0,
  },
  Radio: {
    controlHeightLG: 48,
    borderRadiusLG: 6,
    buttonPaddingInline: 8,
    colorBgContainer: 'var(--color-bg-box)',
  },
  Table: {
    colorBgContainer: 'var(--color-bg-box)',
  },
  Divider: {
    colorSplit: 'var(--border-color)',
  },
  Input: {
    colorBgContainer: 'var(--color-bg-box)',
    colorBgContainerDisabled: 'var(--color-bg-box)',
    activeBg: 'var(--color-bg-box)',
    hoverBg: 'var(--color-bg-box)',
  },
  DatePicker: {
    controlHeightLG: INPUT_HEIGHT_LG,
    colorBgContainer: 'var(--color-bg-box)',
    colorBgContainerDisabled: 'var(--color-bg-box)',
    activeBg: 'var(--color-bg-box)',
    hoverBg: 'var(--color-bg-box)',
    colorBorder: 'var(--input-border-color)',
  },
};

export const commonComponentDarkTheme: ThemeConfig['components'] = {
  Layout: {
    ...commonComponentTheme.Layout,
    lightSiderBg: 'var(--color-bg-box)',
  },
  Menu: {
    ...commonComponentTheme.Menu,
    itemBg: 'var(--color-bg-box)',
    itemSelectedColor: '#000000',
  },
  Card: {
    ...commonComponentTheme.Card,
    colorBgContainer: 'var(--color-bg-box)',
  },
  Button: {
    ...commonComponentTheme.Button,
    primaryColor: 'var(--color-text-button-primary)',
    defaultBg: 'transparent',
    defaultGhostColor: 'var(--colorReverse)',
  },
  Select: {
    ...commonComponentTheme.Select,
    selectorBg: 'var(--color-bg-box)',
    colorBorder: 'var(--color-border)',
  },
  Drawer: {
    ...commonComponentTheme.Drawer,
    colorBgElevated: 'var(--color-bg-box)',
  },
  Modal: {
    contentBg: 'var(--color-bg-box)',
    headerBg: 'var(--color-bg-box)',
  },
};

export const clientPanelLightTheme = {
  'user-card-bg-low': '#ebecf9',
  'user-card-bg-medium': '#fffbe7',
  'user-card-bg-high': '#fbe6ef',
  'cancel-button-bg': '#F6F6F6',
  'cancel-button-color': '#1a2052',
  'save-user-button-bg': '#1a2052',
  'save-user-button-color': '#F6F6F6',
  'risk-level-badge-low': '#179da6',
  'risk-level-badge-medium': '#dd9f00',
  'risk-level-badge-high': '#d20059',
  'kys-status-approved': '#179da6',
  'kys-status-rejected': '#d20059',
  'kys-status-not-required': '#4b4b4b',
  'kys-request-link': '#3240c2',
  'user-card-tag-bg': 'rgb(50 64 194 / 10%)',
  'user-card-tag-color': '#3240c2',
  'color-credit-modal-bg': '#f6f6f6',
  'color-switcher-not-active': '#767997',
  'switcher-bg': '#1a2052',
  'input-border': 'rgb(217, 217, 217)',
  'input-border-hover': 'rgb(45, 52, 94)',
  'input-border-active': '#1a2052',
  'input-shadow-active': 'rgba(4, 8, 21, 0.47)',
  'phonenumber-country-select': '#fff',
  'select-pending-color': '#a0a0a0',
  'select-pending-bgcolor': '#f6f6f6',
  'certificate-card-bg': 'rgba(26, 32, 82, 0.10)',
  'certificate-card-border': '#1A2052',
  'certificate-card-color': '#1A2052',
  'hub-credits-card-bg': 'rgba(255, 211, 14, 0.10)',
  'hub-credits-card-border': '#ffd30e',
  'hub-credits-card-color': '#4b4b4b',
  'coupon-card-bg': 'rgba(23, 157, 166, 0.10)',
  'coupon-card-border': '#179da6',
  'coupon-card-color': '#179da6',
  'competition-reward-card-bg': 'rgba(50, 64, 194, 0.10)',
  'competition-reward-card-border': '#3240c2',
  'competition-reward-card-color': '#3240c2',
  'security-check-badge-status-approved': '#179da6',
  'security-check-badge-status-rejected': '#d20059',
  'security-check-badge-status-in-progress': '#FFD30E',
  'security-check-badge-status-undefined': '#9FA1A4',
};

export const clientPanelDarkTheme = {
  //ask designer about colors
  'user-card-bg-low': '#2d2e42',
  'user-card-bg-medium': '#2e2b20',
  'user-card-bg-high': '#2e2026',
  'cancel-button-bg': '#1C2024',
  'cancel-button-color': '#e8dcc7',
  'save-user-button-bg': '#1a2052',
  'save-user-button-color': '#F6F6F6',
  'risk-level-badge-low': '#179da6',
  'risk-level-badge-medium': '#dd9f00',
  'risk-level-badge-high': '#d20059',
  'kys-request-link': '#3240c2',
  'user-card-tag-bg': ' rgba(159, 168, 255, 0.15)',
  'user-card-tag-color': ' #9fa8ff',
  'color-credit-modal-bg': '#1e1f2a',
  'color-switcher-not-active': '#000',
  'switcher-bg': '#9fa8ff',
  'input-border': 'rgb(66, 66, 66)',
  'input-border-hover': '#e8c52b',
  'input-border-active': '#dcad08',
  'input-shadow-active': 'rgba(180, 127, 0, 0.15)',
  'phonenumber-country-select': '#292e32',
  'select-pending-color': '#fff',
  'select-pending-bgcolor': '#a0a0a0',
  'certificate-card-bg': 'rgba(102, 119, 255, 0.10)',
  'certificate-card-border': '#E9C10F',
  'certificate-card-color': '#E9C10F',
  'hub-credits-card-bg': 'rgba(255, 215, 39, 0.10)',
  'hub-credits-card-border': '#FFD727',
  'hub-credits-card-color': '#8F8F8F',
  'coupon-card-bg': 'rgba(45, 192, 202, 0.10)',
  'coupon-card-border': '#2DC0CA',
  'coupon-card-color': '#2DC0CA',
  'competition-reward-card-bg': 'rgba(170, 178, 255, 0.10)',
  'competition-reward-card-border': '#3240C2',
  'competition-reward-card-color': '#3240C2',
};
